import { useState, useEffect } from 'react';
import { roundDecimal } from '../../../utils/roundingHelpers';

export function useSplitItems(order) {
  const [selected, setSelected] = useState([]);
  const [formedProducts, setFormedProducts] = useState([]);
  const [totalBill, setTotalBill] = useState(0);

  useEffect(() => {
    formatItems();
  }, [order]);

  useEffect(() => {
    calculateTotal();
  }, [selected]);

  const calculateTotal = () => {
    const orderTotal =
      (order.price || {}).leftToPay > 0 ? order.price.leftToPay : (order.price || {}).total || 0;
    let total = 0;

    selected.forEach((product) => {
      if (product.selected) {
        total += product.total;
      }
    });

    setTotalBill(total > orderTotal ? orderTotal : total);
  };

  const formatItems = () => {
    const formatted = [];

    // productId: { quantity }
    const paidProducts = {};
    let totalPaidUnassigned = 0;
    (order.payments || []).forEach((payment) => {
      if (payment.status !== 'Paid') {
        return;
      }

      if (payment.items && payment.items.length > 0) {
        payment.items.forEach((item) => {
          if (paidProducts[item.productId]) {
            paidProducts[item.productId].quantity += item.quantity;
          } else {
            paidProducts[item.productId] = { quantity: item.quantity };
          }
        });
      } else {
        totalPaidUnassigned += payment.amount;
      }
    });

    totalPaidUnassigned = roundDecimal(totalPaidUnassigned);

    (order.products || []).forEach((product) => {
      if (!product.quantity) {
        return;
      }

      if (product.total <= 0) {
        return;
      }

      for (let i = 0; i < product.quantity; i += 1) {
        const paidProduct = paidProducts[product.id];

        let isPaid = false;
        let assignedPaid = 0;

        if (paidProduct && paidProduct.quantity > 0) {
          paidProduct.quantity -= 1;
          isPaid = true;
        } else if (totalPaidUnassigned > 0) {
          if (totalPaidUnassigned <= product.totalSingle) {
            assignedPaid = totalPaidUnassigned;
            totalPaidUnassigned = 0;
          } else {
            isPaid = true;
            totalPaidUnassigned = roundDecimal(totalPaidUnassigned - product.totalSingle);
          }
        }

        formatted.push({
          ...product,
          quantity: 1,
          total: roundDecimal(product.totalSingle - assignedPaid),
          isPaid,
        });
      }
    });

    setFormedProducts(formatted);
  };

  return { totalBill, formedProducts, selected, setSelected };
}
